import decode from 'jwt-decode';
export default (jwt) => {
    try {
        return decode(jwt);
    }
    catch (error) {
        console.error(error);
        return {};
    }
};
//# sourceMappingURL=decode-jwt.js.map